<form class="param-form" [formGroup]="form">
  <app-form>
    <app-row>
      <app-field [label]="'Название параметра'">
        <input
          pInputText
          type="text"
          formControlName="parameter"
          placeholder="Введите id параметра из шаблона"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'Что передаём'">
        <p-dropdown
          formControlName="source"
          placeholder="Выберите значение"
          [options]="sources"
          optionValue="value"
          optionLabel="displayValue"
          [class.loading]="loading"
        />
      </app-field>

      <app-field [label]="'Формат'">
        <input pInputText type="text" formControlName="format" placeholder="Введите формат" [class.loading]="loading" />
      </app-field>
    </app-row>
  </app-form>
</form>
